import { Stack, Typography } from '@mui/material';

import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { ShieldTickFilledIcon } from '@/components/icons/ShieldTickFilledIcon';
import { XCloseIcon } from '@/components/icons/XCloseIcon';
import { COLORS } from '@/styles/tokens/colors';

export interface HouseholdChatPersonaChipProps {
  /** Display name of the applied persona, e.g. "Distribution Evaluation". */
  displayName: string;
  /** Called when the user clears the persona via the chip's remove button. */
  onRemove: () => void;
}

/**
 * Neutral chip shown at the top of the composer while a specialized workflow
 * is applied. Purely presentational: render it only while a persona is active.
 */
export function HouseholdChatPersonaChip({
  displayName,
  onRemove,
}: HouseholdChatPersonaChipProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        width: 'fit-content',
        px: 0.5,
        py: 0.25,
        bgcolor: COLORS.GRAY[50],
        borderRadius: '4px',
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        <ShieldTickFilledIcon
          aria-hidden
          size={16}
          color={COLORS.BRAND.ORANGE}
        />
        <Typography
          variant="body-xs"
          noWrap
          sx={{ color: COLORS.TEXT.PRIMARY }}
        >
          {displayName}
        </Typography>
      </Stack>
      <IconButton
        icon={XCloseIcon}
        ariaLabel={`Remove ${displayName} workflow`}
        variant="transparent"
        size="xs"
        sx={{ p: 0, flexShrink: 0, color: COLORS.GRAY[500] }}
        onClick={onRemove}
      />
    </Stack>
  );
}
